import React, {PureComponent} from 'react'
import {postRequest} from "../../api";
import AdminItemForm from "./AdminItemForm";
import Text from "../Simple/Text";
import Layout from "../Simple/Layout";
import Title from "../Simple/Title";
import {getBooking, updateBookingPrice} from "../../api";


export default class AdminItemModalContent extends PureComponent {
  state = {
    isUpdatePriceModalVisible: false,
  }

  componentWillMount() {
    if (this.props.config.type === 'bookingPriceEdit') {
      this.getBooking()
    }
  }

  getBooking = () => {
    getBooking(this.props.item.id).then(data => {
      this.setState({
        bookingProcess: data.bookingProcess,
        prices: data.prices
      })
    })
  }

  postRequest = (config, item) => {
    const url = config.url
    const confirmationMessage = config.confirmationMessage
    const payload = {}
    for (let field of config.fields) {
      payload[field.name] = item[field.name]
    }
    let content = prompt(confirmationMessage);
    if (content === 'Y') {
      postRequest(url, payload).then((response) => {
        alert(response.message)
      }).catch((response) => {
        if (response && response.message) {
          alert(response.message)
        } else {
          alert('Error.')
        }
      })
    }
  }

  convertCase(str) {
    let lower = String(str).toLowerCase();
    return lower.replace(/(^| )(\w)/g, function (x) {
      return x.toUpperCase();
    });
  }

  formatFieldName(str) {
    return this.convertCase(str.replace('_', ' '))
  }

  onUpdatePrice = (rentPrice, deposit) => {
    const {item} = this.props

    updateBookingPrice(item.id, rentPrice, deposit)
        .then(() => this.getBooking())
        .then(() => this.setState({isUpdatePriceModalVisible: false}))
  }


  doesItemMeetRequirements = (config, item) => {

    if (!config.requirements) {
      return true
    }
    for (let requirement of config.requirements) {
      const operator = requirement.operator ? requirement.operator : '='

      switch (operator) {
        case '=':
          if (!(item[requirement.field] === requirement.value)) {
            return false
          }
          break;
        case '<':
          if (!(item[requirement.field] < requirement.value)) {
            return false
          }
          break;
        case '>':
          if (!(item[requirement.field] > requirement.value)) {
            return false
          }
          break;
        case '<=':
          if (!(item[requirement.field] <= requirement.value)) {
            return false
          }
          break;
        case '>=':
          if (!(item[requirement.field] >= requirement.value)) {
            return false
          }
          break;
      }
    }
    return true;
  }

  render() {
    const {
      item,
      config
    } = this.props

    const {
      isUpdatePriceModalVisible,
      bookingProcess,
      prices
    } = this.state

    const itemMeetsRequirements = this.doesItemMeetRequirements(config, item)

    if (!itemMeetsRequirements) {
      return null;
    }


    return (
        <Layout marginBottom>
          <Title small>{config.title}</Title>
          {config.description && <Layout marginBottomHalf><Text>{config.description}</Text></Layout>}
          {config.type === 'button' &&
          <div className="btn btn-primary btn-sm mb-3 "
               onClick={() => this.postRequest(config, item)}>{config.buttonLabel}</div>
          }
          {config.type === 'form' && <AdminItemForm config={config} item={item}/>}

          {config.type === 'info' &&
          <Layout className="row">
            {config.fields.map((field, fieldKey) => {
              return (
                  <Layout className="col-md-6" marginBottomHalf
                          key={fieldKey}>
                    <label>{field['label']}</label>
                    <div style={{fontWeight: 500}}>{field['prefix']}{item[field['field']]}{field['postfix']}</div>
                  </Layout>
              )
            })}
          </Layout>}
          {config.type === 'bookingPriceEdit' && (<>
            <div className="btn btn-primary btn-sm mb-3 "
                 onClick={() => this.setState({isUpdatePriceModalVisible: true})}>{config.buttonLabel}
            </div>
          </>)
          }
        </Layout>
    )
  }
}
